import { render, staticRenderFns } from "./LikeButton.vue?vue&type=template&id=de6529ec&"
import script from "./LikeButton.vue?vue&type=script&lang=js&"
export * from "./LikeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports